<app-bottom-sheet [(isOpen)]="isOpen"
                  [isFullScreen]="true"
                  [preventOverlayClose]="false"
                  [hasFooter]="false"
                  [enableSwipeToDismiss]="true"
                  [headerTemplate]="headerTemplate"
                  [contentTemplate]="contentTemplate">
</app-bottom-sheet>

<ng-template #headerTemplate>
  <div class="filter-panel-header">
    <div class="filter-panel-header-start">
      @if (currentView() === 'sub') {
        <p-button icon="pi pi-angle-left"
                  [text]="true"
                  severity="secondary"
                  styleClass="filter-panel-back-button"
                  (onClick)="backToList()"
                  [attr.data-testid]="testId() + '-back'"
                  aria-label="Back to filter categories" />
      }
    </div>
    <span class="filter-panel-title">
      {{ currentView() === 'list' ? title() : (activeCategory()?.label ?? '') }}
    </span>
    <div class="filter-panel-header-end">
      @if (currentView() === 'list' && draftCount() > 0) {
        <p-button label="Clear All"
                  [text]="true"
                  severity="secondary"
                  styleClass="filter-panel-clear-button"
                  (onClick)="clearAllDraft()"
                  [attr.data-testid]="testId() + '-clear-all'" />
      }
    </div>
  </div>
</ng-template>

<ng-template #contentTemplate>
  <div class="filter-panel-body"
       [attr.data-testid]="testId()">
    <div class="filter-panel-slide-track"
         [class.at-sub]="currentView() === 'sub'">

      <!-- Panel 1: category list -->
      <div class="filter-panel-slide filter-panel-slide--list">
        @for (def of definitions(); track def.id) {
          <button class="filter-category-row"
                  (click)="openCategory(def.id)"
                  [attr.data-testid]="testId() + '-category-' + def.id">
            <span class="filter-category-name">
              {{ def.label }}
              @if (def.isChoice) {
                @if (choiceLabel(def); as choice) {
                  <p-badge [value]="choice"
                           styleClass="filter-category-badge" />
                }
              } @else if (categoryCount(def.id) > 0) {
                <p-badge [value]="categoryCount(def.id).toString()"
                         styleClass="filter-category-badge" />
              }
            </span>
            <span class="filter-category-end">
              <i class="pi pi-angle-right filter-category-chevron"></i>
            </span>
          </button>
        }

        <div class="filter-selected-section">
          <p class="filter-selected-title">Selected Filters</p>
          @if (draftChips().length === 0) {
            <p class="filter-no-selection">No filters selected yet</p>
          } @else {
            <div class="filter-draft-chips">
              @for (chip of draftChips(); track chip.filterId + chip.value) {
                <p-chip [label]="chip.displayLabel"
                        [removable]="chip.removable"
                        [removeIcon]="'pi pi-times'"
                        styleClass="filter-active-chip"
                        (onRemove)="removeDraftChip(chip.filterId, chip.value)" />
              }
            </div>
          }
        </div>
      </div>

      <!-- Panel 2: sub-category options -->
      <div class="filter-panel-slide filter-panel-slide--sub">
        @if (activeCategory(); as category) {
          @if (!category.isChoice) {
            <div class="filter-sub-toolbar">
              <p-button [label]="'Select All'"
                        [text]="true"
                        severity="secondary"
                        styleClass="filter-sub-link-button"
                        (onClick)="selectAllForCategory(activeCategoryId()!)" />
              <p-button label="Clear"
                        [text]="true"
                        severity="secondary"
                        styleClass="filter-sub-link-button"
                        (onClick)="clearCategory(activeCategoryId()!)" />
            </div>
          }

          @if (activeCategoryValues().length === 0) {
            <p class="filter-option-empty">No options available yet.</p>
          } @else {
            @for (option of activeCategoryValues(); track option.value) {
              <div class="filter-option"
                   [class.filter-option--checked]="option.selected"
                   (click)="toggleDraftValue(activeCategoryId()!, option.value)"
                   [attr.role]="category.isChoice ? 'radio' : 'checkbox'"
                   [attr.aria-checked]="option.selected"
                   [attr.data-testid]="testId() + '-option-' + option.value"
                   tabindex="0"
                   (keydown.space)="$event.preventDefault(); toggleDraftValue(activeCategoryId()!, option.value)"
                   (keydown.enter)="toggleDraftValue(activeCategoryId()!, option.value)">
                <input [type]="category.isChoice ? 'radio' : 'checkbox'"
                       [checked]="option.selected"
                       tabindex="-1"
                       aria-hidden="true">
                <span>{{ option.label }}</span>
              </div>
            }
          }
        }
      </div>

    </div>

    <div class="filter-panel-footer">
      <p-button [label]="applyLabel()"
                severity="contrast"
                styleClass="bqa-primary-btn p-fullwidth-button"
                (onClick)="apply()"
                [attr.data-testid]="testId() + '-apply'" />
    </div>
  </div>
</ng-template>
